export const CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS = 'CLUBS:FETCH_HIGHSCHOOL_STANDINGS_SEASONS';
export const CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_SUCCESS = 'CLUBS:FETCH_HIGHSCHOOL_STANDINGS_SEASONS_SUCCESS';
export const CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SEASONS_FAILURE = 'CLUBS:FETCH_HIGHSCHOOL_STANDINGS_SEASONS_FAILURE';
export const CLUBS_FETCH_HIGHSCHOOL_STANDINGS = 'CLUBS:FETCH_HIGHSCHOOL_STANDINGS';
export const CLUBS_FETCH_HIGHSCHOOL_STANDINGS_SUCCESS = 'CLUBS:FETCH_HIGHSCHOOL_STANDINGS_SUCCESS';
export const CLUBS_FETCH_HIGHSCHOOL_STANDINGS_FAILURE = 'CLUBS:FETCH_HIGHSCHOOL_STANDINGS_FAILURE';

// Add/Update Player on Roster
export const CLUB_ADD_UPDATE_PLAYER_ON_ROSTER = 'CLUB:ADD_UPDATE_PLAYER_ON_ROSTER';
export const CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_SUCCESS = 'CLUB:ADD_UPDATE_PLAYER_ON_ROSTER_SUCCESS';
export const CLUB_ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE = 'CLUB:ADD_UPDATE_PLAYER_ON_ROSTER_FAILURE';
export const CLUB_ADD_PLAYER_TO_ROSTER_OPTIMISTIC = 'CLUB:ADD_PLAYER_TO_ROSTER_OPTIMISTIC';

// Remove Player from Roster
export const CLUB_REMOVE_PLAYER_FROM_ROSTER = 'CLUB:REMOVE_PLAYER_FROM_ROSTER';
export const CLUB_REMOVE_PLAYER_FROM_ROSTER_SUCCESS = 'CLUB:REMOVE_PLAYER_FROM_ROSTER_SUCCESS';
export const CLUB_REMOVE_PLAYER_FROM_ROSTER_FAILURE = 'CLUB:REMOVE_PLAYER_FROM_ROSTER_FAILURE';
export const CLUB_REMOVE_PLAYER_FROM_ROSTER_OPTIMISTIC = 'CLUB:REMOVE_PLAYER_FROM_ROSTER_OPTIMISTIC';

// Set Player Redshirt Status
export const CLUB_SET_PLAYER_REDSHIRT_STATUS = 'CLUB:SET_PLAYER_REDSHIRT_STATUS';
export const CLUB_SET_PLAYER_REDSHIRT_STATUS_SUCCESS = 'CLUB:SET_PLAYER_REDSHIRT_STATUS_SUCCESS';
export const CLUB_SET_PLAYER_REDSHIRT_STATUS_FAILURE = 'CLUB:SET_PLAYER_REDSHIRT_STATUS_FAILURE';
export const CLUB_UPDATE_PLAYER_REDSHIRT_STATUS_IN_ROSTER = 'CLUB:UPDATE_PLAYER_REDSHIRT_STATUS_IN_ROSTER';
